// Sidebar-Zähler (S53b) — ein Event-gestützter Abgleich für die Arbeitsvorräte:
// unbeantwortete Kundennachrichten, aktionsbedürftige Retouren,
// lieferbare Bestellungen. Die Seiten invalidieren den Key bei
// Mutationen mit, damit die Badges sofort nachziehen statt bis zum
// Recovery-Polling läuft nur, solange der Realtime-Stream getrennt ist.

import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../lib/api";
import { useRealtimeRecoveryInterval } from "../features/realtime/realtimeEvents";

export interface NotificationBadges {
  messagesOpen: number;
  returnsActionable: number;
  ordersOpen: number;
  advertisingAttention: number;
  advertisingConnectionIssue: boolean;
}

export const NOTIFICATION_BADGES_KEY = ["notification-badges"] as const;

export function useNotificationBadges(options?: { enabled?: boolean }) {
  const recoveryInterval = useRealtimeRecoveryInterval();
  return useQuery({
    queryKey: NOTIFICATION_BADGES_KEY,
    queryFn: (): Promise<NotificationBadges> =>
      api.get("/api/notification-badges").then((r: { data: NotificationBadges }) => r.data),
    enabled: options?.enabled ?? true,
    staleTime: 30_000,
    refetchInterval: recoveryInterval,
  });
}

export function useInvalidateNotificationBadges() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: NOTIFICATION_BADGES_KEY });
}
